import SHRMButton from '../../../../../../common/components/SHRMButton';
import membershipCard from './assets/membershipcard.jpg';
import styles from './MembershipCardModal.module.css';

type CardModalProps = {
  isModalOpen: boolean;
  membership: any;
  expirationDate: string;
  closeModal: (e) => any;
  printCard: (isCard: boolean, isLetterSize: boolean) => any;
};

const MembershipCardModal = (props: CardModalProps) => {
  const handlePrint = () => {
    props.printCard(true, true);
  };

  return (
    <div>
      {props.isModalOpen && (
        <div className={styles.container} onClick={props.closeModal}>
          <div
            className={styles.content}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className={styles.header}>
              <label className={styles.title}>SHRM MEMBERSHIP CARD</label>
              <button className={styles.closeModalButton} onClick={props.closeModal}>
                ×
              </button>
            </div>
            <div className={styles.text}>
              To create your SHRM membership card, please review the details of your membership
              listed below. Once verified you may then generate a membership PDF that you can print
              to your personal printer.
            </div>
            <SHRMButton className={styles.generateCardButton} onClick={handlePrint}>
              generate membership card
            </SHRMButton>
            <div className={styles.previewLabel}>preview</div>
            <div className={styles.membershipCard}>
              <img src={membershipCard} />
              <span className={styles.name}>{props.membership.memberNameCredentials}</span>
              <span className={styles.memberToDate}>
                is a member in good standing through{' '}
                <strong>{props.membership.memberThrough}</strong>
              </span>
              <span className={styles.memberSinceDate}>
                MEMBER SINCE: {props.membership.memberSince}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipCardModal;
